import { render, staticRenderFns } from "./AppDownloadView.vue?vue&type=template&id=921ba752&"
import script from "./AppDownloadView.vue?vue&type=script&lang=js&"
export * from "./AppDownloadView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports